
import { AddIcon } from "@chakra-ui/icons";
import {  Box, Circle,IconButton,Text} from "@chakra-ui/react";

export const resourceTitle = "Cadastro de depósito";
export const resourceSingularName = "Depósito";
export const resourcePluralName = "Depósitos";

// @todo: review endpoint
export const resourceKey = "endereco/deposito";

export const idKey = "id";



const headers = [
  { label: 'Selecionar',
    key: 'checkbox',
    isVisible: true 
  },
  {
    key: "id",
    label: "ID",
    isVisible: true,
  },
  {
    key: "status",
    label: "Status",
    isVisible: true,
  },
{
  key: "tipoCarga",
  label: "Tipo Carga",
  isVisible: true,
  render: (value: string, item: any) => {
    const getTipoCargaConfig = (tipo: string) => {
      const tipoLower = String(tipo).toLowerCase();
      if (tipoLower === "frios") return { 
        bg: "#1e90ff", 
        color: "white", 
        icon: "F", 
        iconBg: "#1e90ff" 
      };
      if (tipoLower === "secos") return { 
        bg: "#ffd700", 
        color: "white", 
        icon: "S", 
        iconBg: "#ffd700" 
      };
      if (tipoLower === "misto") return { 
        bg: "#8B4513", 
        color: "white", 
        icon: "M", 
        iconBg: "#8B4513" 
      };
      return { bg: "#718096", color: "white", icon: "?", iconBg: "#718096" };
    };

    if (!value) return "-";
    
    const config = getTipoCargaConfig(value);
    
    return (
      <Box display="flex" alignItems="center" gap={2}>
        <Circle size="20px" bg={config.iconBg} color={config.color} fontSize="xs" fontWeight="bold">
          {config.icon}
        </Circle>
        <Text fontSize="sm" fontWeight="medium" textTransform="capitalize">
          {value}
        </Text>
      </Box>
    );
  }
},
{
  key: "prioridade",
  label: "Prioridade",
  isVisible: true,
  render: (value: string, item: any) => {
    const getPrioridadeConfig = (prioridade: string) => {
      const prioridadeLower = String(prioridade).toLowerCase();
      if (prioridadeLower === "baixa") return { 
        bg: "#28a745", 
        color: "white", 
        icon: "B", 
        iconBg: "#28a745" 
      };
      if (prioridadeLower === "normal") return { 
        bg: "#fd7e14", 
        color: "white", 
        icon: "N", 
        iconBg: "#ffd700" 
      };
      if (prioridadeLower === "urgente") return { 
        bg: "#dc3545", 
        color: "white", 
        icon: "U", 
        iconBg: "#dc3545" 
      };
      return { bg: "#718096", color: "white", icon: "?", iconBg: "#718096" };
    };

    if (!value) return "-";
    
    const config = getPrioridadeConfig(value);
    
    return (
      <Box display="flex" alignItems="center" gap={2}>
        <Circle size="20px" bg={config.iconBg} color={config.color} fontSize="xs" fontWeight="bold">
          {config.icon}
        </Circle>
        <Text fontSize="sm" fontWeight="medium" textTransform="capitalize">
          {value}
        </Text>
      </Box>
    );
  }
},
  {
    key: "tipoCarro",
    label: "Tipo de carro",
    isVisible: true,
  },
  {
    key: "dataDemanda",
    label: "Data Demanda",
    isVisible: true,
  },
  {
    key: "origem",
    label: "Origem",
    isVisible: true,
  },
  {
    key: "destino",
    label: "Destino",
    isVisible: true,
  },
  {
    key: "obs",
    label: "Obs",
    isVisible: true,
  },
  {
    key: "comentario",
    label: "Comentário",
    isVisible: true,
    render: (_value: string, item: any) => (
      <Box display="flex" justifyContent={'center'} alignItems="center" gap={2}>
        <IconButton
          aria-label="Add"
          icon={<AddIcon />}
          onClick={()=>  window.location.href = `/acompanhamento-portaria/acompanhamento-contratacao/comentario/${item.id}`}
          colorScheme="green"
          size="xs"
          borderRadius="full"
        />
      </Box>
    )
  }
];

export default headers;

export const mockData = [
  {
    id: 1,
    status: "Pendente",
    tipoCarga: "Frios",
    prioridade: "Urgente",
    tipoCarro: "Truck",
    dataDemanda: "2025-07-02",
    origem: "São Paulo",
    destino: "Rio de Janeiro",
    obs: "Carga frágil, manusear com cuidado.",
    comentario: "Urgente, cliente VIP."
  },
  {
    id: 2,
    status: "Concluído",
    tipoCarga: "Secos",
    prioridade: "Normal",
    tipoCarro: "VUC",
    dataDemanda: "2025-07-01",
    origem: "Campinas",
    destino: "Belo Horizonte",
    obs: "Evitar horário de pico.",
    comentario: "Entregue sem avarias."
  },
  {
    id: 3,
    status: "Em andamento",
    tipoCarga: "Misto",
    prioridade: "Baixa",
    tipoCarro: "Carreta",
    dataDemanda: "2025-06-30",
    origem: "Curitiba",
    destino: "Porto Alegre",
    obs: "Aguardar liberação fiscal.",
    comentario: ""
  },
  {
    id: 4,
    status: "Pendente",
    tipoCarga: "Secos",
    prioridade: "Normal",
    tipoCarro: "Utilitário",
    dataDemanda: "2025-07-03",
    origem: "Recife",
    destino: "Fortaleza",
    obs: "Entrega programada para tarde.",
    comentario: "Aguardando confirmação do cliente."
  },
  {
    id: 5,
    status: "Cancelado",
    tipoCarga: "",
    prioridade: "",
    tipoCarro: "Outro",
    dataDemanda: "2025-06-29",
    origem: "Salvador",
    destino: "Maceió",
    obs: "",
    comentario: "Cancelado por falha de documentação."
  }
];

